module.exports = __webpack_public_path__ + "img/project10_10.jpg.c994f848.webp";